import { FC, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { createTheme } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { ThemeProvider } from "@material-ui/core";

import { withStyles, createStyles, Theme } from "@material-ui/core/styles";
import { AppState } from "../../../redux/reducers/rootReducer";
import { useStyles } from "../../../shared/styles/useStyles";
import { CustomizedTableFooter } from "../../custom/CustomizedTableFooter";
import { CorrespondenceBody } from "./CorrespondenceBody";
import { ICorrespondence } from "../../../interfaces/Correspondence";
import clsx from "clsx";
import { getMilestonesByUserId } from "../../../services/firebase/correspondence";
import { restricUser } from "../../../module/admin/firebase/UsersService";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
    fontSize: 11,
  },
});

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    root: {
      whiteSpace: "nowrap",
    },
    head: {
      height: "40px",
    },
  })
)(TableCell);

interface props {
  readOnly?: boolean;
  pqrs?: boolean;
  rows?: ICorrespondence[] | null;
  component?: string;
  showState?: boolean;
  user?: {id: number, restricUser: boolean};
}
export const CorrespondenceTable: FC<props> = ({
  user,
  readOnly = false,
  pqrs = false,
  rows = null,
  component = "OTHER",
  showState = false
}) => {

  const classes = useStyles();
  const { data, value } = useSelector((state: AppState) => state.search);
  const [count, setCount] = useState(0);
  // Paginación
  const { page, rowsPerPage } = useSelector((state: AppState) => state.pagination);
  
  useEffect(() => {
    if (data) {
      setCount(data.length);
    }
    
  }, [data, count, rowsPerPage])
  return (
    <ThemeProvider theme={theme}>
      <TableContainer component={Paper} className={classes.heightTable}>
        <Table
          className={classes.table}
          size="small"
          style={{ width: "auto" }}
          aria-label="custom pagination table"
        >
          <TableHead className={classes.titleTable}>
            <TableRow>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="Settled" />{" "}
              </StyledTableCell>
              <StyledTableCell
                width={150}
                align="center"
                className={classes.titleTable}
              >
                <FormattedMessage id="InputType" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="CommunicationType" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="Subject" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="Date" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="Dependency" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="Addressee" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="Sender" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="TrafficLight" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="Attachments" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="EmailsSended" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="FLR" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="DR" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="ER" />{" "}
              </StyledTableCell>
              <StyledTableCell align="center" className={classes.titleTable}>
                <FormattedMessage id="EA" />{" "}
              </StyledTableCell>
              {showState && (
                <StyledTableCell
                  align="center"
                  className={classes.titleTable}
                >
                  <FormattedMessage id="State" />{" "}
                </StyledTableCell>
              )}
              {!readOnly && (
                <StyledTableCell
                  align="center"
                  className={clsx(classes.titleTable, classes.fixedColumn)}
                >
                  <FormattedMessage id="Actions" />{" "}
                </StyledTableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody style={{ tableLayout: "auto" }}>
            {(rowsPerPage > 0 ? data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data
            )?.map((row) => (
              <CorrespondenceBody communication={row}
                key={row.id}
                readOnly={readOnly}
                isDocManagment
                isRead={row.isReaded}
                component={component}
                showState={showState}
                user={{id: user != null ? user.id : 0, restricUser: user != null ? user.restricUser : false}} />)
            )}
            
          </TableBody>
          {/* --------- Footer para paginación -------- */}
          <CustomizedTableFooter count={count} rowsPerPage={rowsPerPage} page={page}/>
        </Table>
      </TableContainer>
    </ThemeProvider>
  );
};
